const SpeakerphoneIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.16623 4.90167V16.0333C9.16599 16.3787 9.04385 16.7129 8.82135 16.9771C8.59885 17.2413 8.29026 17.4185 7.94994 17.4774C7.60962 17.5364 7.25941 17.4734 6.961 17.2994C6.6626 17.1255 6.43515 16.8518 6.31873 16.5267L4.52957 11.4017M4.52957 11.4017C3.82225 11.1009 3.24055 10.5659 2.88292 9.88555C2.5253 9.20523 2.4137 8.42223 2.56701 7.66908C2.72033 6.91593 3.12914 6.23888 3.72427 5.7525C4.31941 5.26612 5.0643 5.00029 5.8329 5H7.35957C10.7762 5 13.7137 3.97167 14.9996 2.5V14.1667C13.7137 12.695 10.7771 11.6667 7.35957 11.6667H5.8329C5.38509 11.6673 4.94178 11.5766 4.52957 11.4017ZM14.9996 10.8333C15.6626 10.8333 16.2985 10.5699 16.7673 10.1011C17.2362 9.63226 17.4996 8.99637 17.4996 8.33333C17.4996 7.67029 17.2362 7.03441 16.7673 6.56557C16.2985 6.09673 15.6626 5.83333 14.9996 5.83333V10.8333Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SpeakerphoneIcon;
